export const productsData = {
  // 清新洗面乳 150g
  4711441361716: {
    name: '清新洗面乳 150g',
    number: '4711441361716',
    price: '290',
    img: {
      white_bg: '4711441361716_1260.jpg',
      usage: '',
    },
    alt: '',
    description: '含有炭和海淤泥等成分，泡沫綿密能溫和去除老廢角質和毛孔污垢，保持肌膚潔淨。',
  },
  // 清新潔淨泥膜 150g
  4711441361723: {
    name: '清新潔淨泥膜 150g',
    number: '4711441361723',
    price: '490',
    img: {
      white_bg: '4711441361723_1260.jpg',
      usage: '',
    },
    alt: '',
    description: '添加海淤泥及皂土，能吸附多餘的皮脂和毛孔污垢，深層清潔肌膚，使肌膚潔淨透亮。',
  },
  // 清新角質調理化妝水 300ml
  4711441361730: {
    name: '清新角質調理化妝水 300ml',
    number: '4711441361730',
    price: '390',
    img: {
      white_bg: '4711441361730_1260.jpg',
      usage: '',
    },
    alt: '',
    description: '溫和去除老廢角質和毛孔污垢。為乾燥粗糙的肌膚補充水分，保持肌膚潔淨，同時幫助調整肌膚狀態。',
  },
  // 清新化妝水 300ml
  4711441361747: {
    name: '清新化妝水 300ml',
    number: '4711441361747',
    price: '390',
    img: {
      white_bg: '4711441361747_1260.jpg',
      usage: '',
    },
    alt: '',
    description:
      '能調理因肌膚不平衡而引起的粗糙和毛孔問題，維持肌膚的健康，呈現平滑細緻。提供兩款保濕度，滿足不同肌膚需求。',
  },
  // 清新化妝水(保濕型) 300ml
  4711441361754: {
    name: '清新化妝水(保濕型) 300ml',
    number: '4711441361754',
    price: '390',
    img: {
      white_bg: '4711441361754_1260.jpg',
      usage: '',
    },
    alt: '',
    description:
      '能調理因肌膚不平衡而引起的粗糙和毛孔問題，維持肌膚的健康，呈現平滑細緻。提供兩款保濕度，滿足不同肌膚需求。',
  },
  // 清新乳液 200ml
  4711441361761: {
    name: '清新乳液 200ml',
    number: '4711441361761',
    price: '390',
    img: {
      white_bg: '4711441361761_1260.jpg',
      usage: '',
    },
    alt: '',
    description: '清爽的使用感，也能有效鎖水，調理肌理，讓肌膚變得細緻光滑。',
  },
  // 清新ALL IN ONE美容凝膠 150ml
  4711441361778: {
    name: '清新ALL IN ONE美容凝膠 150ml',
    number: '4711441361778',
    price: '390',
    img: {
      white_bg: '4711441361778_1260.jpg',
      usage: '',
    },
    alt: '',
    description: '結合化妝水、乳液和美容液，適合忙碌的早晨或想要輕鬆護理的日子，簡單一瓶即可完成全方位護理。',
  },
  // 清新皮脂平衡局部精華 10g
  4711441361785: {
    name: '清新皮脂平衡局部精華 10g',
    number: '4711441361785',
    price: '390',
    img: {
      white_bg: '4711441361785_1260.jpg',
      usage: '',
    },
    alt: '',
    description:
      '添加維他命C誘導體的美白成分，針對肌膚暗沉等重點區域進行集中護理，質地清爽，呈現透明凝凍感的局部精華。',
  },
  // 米糠發酵導入美容液/50ml
  4711441361327: {
    name: '米糠發酵導入美容液/50ml',
    number: '4711441361327',
    price: '499',
    img: {
      white_bg: '4711441361327_1260.jpg',
      usage: '',
    },
    alt: '',
  },
  // 化妝棉/180入/約65x50mm
  4550583926762: {
    name: '化妝棉/180入/約65x50mm',
    number: '4550583926762',
    price: '99',
    img: {
      white_bg: '4550583926762_1260.jpg',
      usage: '',
    },
    alt: '',
  },
  // 可撕型化妝棉/86入/約85x60mm
  4550583926755: {
    name: '可撕型化妝棉/86入/約85x60mm',
    number: '4550583926755',
    price: '99',
    img: {
      white_bg: '4550583926755_1260.jpg',
      usage: '',
    },
    alt: '',
  },
  // 原色化妝棉/大片.88入/約90x70mm
  4550583926748: {
    name: '原色化妝棉/大片.88入/約90x70mm',
    number: '4550583926748',
    price: '99',
    img: {
      white_bg: '4550583926748_1260.jpg',
      usage: '',
    },
    alt: '',
  },
  // 原色化妝棉/180入
  4549337318885: {
    name: '原色化妝棉/180入',
    number: '4549337318885',
    price: '79',
    img: {
      white_bg: '4549337318885_1260.jpg',
      usage: '',
    },
    alt: '',
  },
  // 壓邊化妝棉/189入
  4549337318915: {
    name: '壓邊化妝棉/189入',
    number: '4549337318915',
    price: '79',
    img: {
      white_bg: '4549337318915_1260.jpg',
      usage: '',
    },
    alt: '',
  },
  // 壓頭/化妝棉專用(化妝水用)
  4549337775541: {
    name: '壓頭/化妝棉專用(化妝水用)',
    number: '4549337775541',
    price: '140',
    img: {
      white_bg: '4549337775541_1260.jpg',
      usage: '',
    },
    alt: '',
  },
  // 握柄式噴霧頭(化妝水用)
  4547315252725: {
    name: '握柄式噴霧頭(化妝水用)',
    number: '4547315252725',
    price: '100',
    img: {
      white_bg: '4547315252725_1260.jpg',
      usage: '',
    },
    alt: '',
  },
  // 噴霧頭(化妝水用)
  4945247188240: {
    name: '噴霧頭(化妝水用)',
    number: '4945247188240',
    price: '70',
    img: {
      white_bg: '4945247188240_1260.jpg',
      usage: '',
    },
    alt: '',
  },
  // 壓頭(化妝水.乳液用)
  4945247188257: {
    name: '壓頭(化妝水.乳液用)',
    number: '4945247188257',
    price: '80',
    img: {
      white_bg: '4945247188257_1260.jpg',
      usage: '',
    },
    alt: '',
  },
};

export const dailyData = [
  {
    id: 1,
    title: '每日的基礎保養',
    subtitle: '',
    description: '',
    products: [
      {
        id: 1,
        item: '4711441361730',
        tag: '溫和清潔',
      },
      {
        id: 2,
        item: '4711441361747',
        tag: '基礎補水',
        type: [
          {
            text: '清爽型',
            number: '4711441361747',
            active: true,
          },
          {
            text: '保濕型',
            number: '4711441361754',
            active: false,
          },
        ],
      },
      {
        id: 3,
        item: '4711441361754',
        tag: '基礎補水',
        type: [
          {
            text: '清爽型',
            number: '4711441361747',
            active: false,
          },
          {
            text: '保濕型',
            number: '4711441361754',
            active: true,
          },
        ],
      },
      {
        id: 4,
        item: '4711441361761',
        tag: '鎖住水分',
      },
    ],
  },
  {
    id: 2,
    title: '每日的肌膚護理',
    subtitle: '調理肌膚基礎',
    description: '',
    products: [
      {
        id: 1,
        item: '4711441361785',
        tag: '重點護理',
      },
      {
        id: 2,
        item: '4711441361778',
        recommend: '入門推薦',
        tag: '簡單護理',
      },
    ],
  },
  {
    id: 3,
    title: '每日的肌膚清潔',
    subtitle: '',
    description: '針對毛孔護理，清潔護理是重要的步驟。',
    products: [
      {
        id: 1,
        item: '4711441361716',
        tag: '每日清潔',
      },
      {
        id: 2,
        item: '4711441361723',
        recommend: '推薦商品',
        tag: '深層潔淨',
      },
    ],
  },
];

export const lineupData = [
  {
    id: 1,
    item: '4549337318885',
  },
  {
    id: 2,
    item: '4549337318915',
  },
  {
    id: 3,
    item: '4550583926762',
  },
  {
    id: 4,
    item: '4550583926755',
  },
  {
    id: 5,
    item: '4550583926748',
  },
  {
    id: 6,
    item: '4549337775541',
  },
  {
    id: 7,
    item: '4547315252725',
  },
  {
    id: 8,
    item: '4945247188240',
  },
  {
    id: 9,
    item: '4945247188257',
  },
];

export const reportData = [
  {
    id: 1,
    link: 'https://www.muji.tw/tw/feature/24ss/ricebran/index.html',
    img: '640X400_ricebran_250407.jpg',
    text: '米糠發酵臉部保養系列',
  },
  {
    id: 2,
    link: 'https://www.muji.tw/tw/feature/fragrance/',
    img: '640X400_fragrance_250331.jpg',
    text: '香氣・空間香氛 伴隨著香氛的生活',
  },
  {
    id: 3,
    link: 'https://www.muji.tw/tw/feature/sensitiveskin/',
    img: '640X400_sensitiveskin_250212.jpg',
    text: '敏感肌臉部保養系列',
  },
  {
    id: 4,
    link: 'https://www.muji.tw/tw/feature/shampoo/',
    img: '640X400-0630-3.jpg',
    text: ' 無印良品的頭髮護理',
  },
  {
    id: 5,
    link: 'https://www.muji.tw/tw/feature/healthandbeauty/',
    img: 'Face-640X400-0301.jpg',
    text: '水漾潤澤',
  },
];
